import { useRef } from "react";
import sendIcon from "./images/Send.png";
import Button from "./Button/Button";

const SearchForm = ({ handleSearch }) => {
  const titleRef = useRef();

  return (
    <div className="update-form">
      <textarea ref={titleRef} className="update-form-input" rows={2} />
      <div
        className="update-form-btn"
        onClick={() => handleSearch(titleRef.current.value)}
      >
        <Button activation={true} image={sendIcon} />
      </div>
    </div>
  );
};

export default SearchForm;
